import { useLayoutEffect, useState, useMemo } from 'react';
import { IconButton } from '../../../layout/form';
import AddressModal from './addressModal';
import { useRouteMatch } from 'react-router-dom/cjs/react-router-dom.min';
import { logOut, registerRoutes } from '../../../func';
import Axios from 'axios';
import { useDispatch } from 'react-redux';

const AddressesTab = ({ pharmacy, refresh }) => {
  const { path } = useRouteMatch();
  const dispatch = useDispatch();
  const authData = useMemo(
    () => JSON.parse(localStorage.getItem('auth_data')),
    []
  );

  const [isAddressModalOpen, setIsAddressModalOpen] = useState(false);
  const [selectedAddress, setSelectedAddress] = useState(null);

  const networkCalls = useMemo(
    () =>
      registerRoutes(
        {
          deleteAddress: {
            func: pharmacyAddressId => {
              if (
                !window.confirm('Are you sure you want to delete this address?')
              )
                return;

              Axios.delete('/api/v2/pharmacyaddress/delete/one', {
                data: { ...authData, pharmacyAddressId },
              })
                .then(result => {
                  refresh();
                  dispatch(result.data);
                })
                .catch(logOut);
            },
            type: 'd',
          },
          updateDefaultAddress: {
            func: pharmacyAddressId => {
              Axios.put('/api/v2/pharmacyaddress/update/defaultaddress', {
                ...authData,
                pharmacyAddressId,
              })
                .then(result => {
                  refresh();
                  dispatch(result.data);
                })
                .catch(logOut);
            },
          },
        },
        path
      ),
    [path, authData, dispatch, refresh]
  );

  const autoAdjustHeights = () => {
    const cards = document.querySelectorAll('div.card.address-card');

    cards.forEach(card => {
      const labelElements = card.querySelectorAll('table#t-labels>tbody>tr');
      const valueElements = card.querySelectorAll('table#t-values>tbody>tr');

      labelElements.forEach((labelElement, index) => {
        valueElements[index].style.height = `${labelElement.clientHeight}px`;
      });
    });
  };

  useLayoutEffect(() => {
    window.addEventListener('resize', autoAdjustHeights);
    return () => {
      window.removeEventListener('resize', autoAdjustHeights);
    };
  }, []);

  useLayoutEffect(() => {
    autoAdjustHeights();
  }, [pharmacy]);

  const updateDefaultAddress = (event, pharmacyAddressId) => {
    event?.preventDefault();
    networkCalls.updateDefaultAddress(pharmacyAddressId);
  };

  return (
    <div style={{ padding: '1vw' }}>
      <div className="row">
        <IconButton
          icon="add"
          onClick={() => {
            setSelectedAddress(null);
            setIsAddressModalOpen(true);
          }}
        />
      </div>
      <div className="row">
        {pharmacy?.pharmacyAddresses
          ?.sort((a, b) => a.id - b.id)
          .map(address => {
            const {
              id,
              addressLineOne,
              addressLineTwo,
              addressLineThree,
              addressType,
              city,
              state,
              postalCode,
              isDefault,
            } = address;
            return (
              <div key={id} className="card address-card">
                <div className="card-content">
                  <div
                    className="row"
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      justifyContent: 'flex-end',
                    }}
                  >
                    <IconButton
                      icon="delete"
                      onClick={() => networkCalls.deleteAddress(id)}
                    />
                    <IconButton
                      icon="edit"
                      onClick={() => {
                        setSelectedAddress(address);
                        setIsAddressModalOpen(true);
                      }}
                    />
                  </div>
                  <div className="row">
                    <div className="col s4 m3 l2">
                      <table id="t-labels">
                        <tbody>
                          <tr>
                            <td
                              className="bold"
                              style={{ textAlign: 'right', padding: '4px' }}
                            >
                              ID
                            </td>
                          </tr>
                          <tr>
                            <td
                              className="bold"
                              style={{ textAlign: 'right', padding: '4px' }}
                            >
                              Address Line One
                            </td>
                          </tr>
                          <tr>
                            <td
                              className="bold"
                              style={{ textAlign: 'right', padding: '4px' }}
                            >
                              Address Line Two
                            </td>
                          </tr>
                          <tr>
                            <td
                              className="bold"
                              style={{ textAlign: 'right', padding: '4px' }}
                            >
                              Address Line Three
                            </td>
                          </tr>
                          <tr>
                            <td
                              className="bold"
                              style={{ textAlign: 'right', padding: '4px' }}
                            >
                              City, State
                            </td>
                          </tr>
                          <tr>
                            <td
                              className="bold"
                              style={{ textAlign: 'right', padding: '4px' }}
                            >
                              Postal Code
                            </td>
                          </tr>
                          <tr>
                            <td
                              className="bold"
                              style={{ textAlign: 'right', padding: '4px' }}
                            >
                              Address Type
                            </td>
                          </tr>
                          <tr>
                            <td
                              className="bold"
                              style={{ textAlign: 'right', padding: '4px' }}
                            >
                              Is Default?
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div className="col s8 m9 l10">
                      <table id="t-values" className="highlight">
                        <tbody>
                          <tr>
                            <td style={{ padding: '4px' }}>{id}</td>
                          </tr>
                          <tr>
                            <td style={{ padding: '4px' }}>{addressLineOne}</td>
                          </tr>
                          <tr>
                            <td style={{ padding: '4px' }}>{addressLineTwo}</td>
                          </tr>
                          <tr>
                            <td style={{ padding: '4px' }}>
                              {addressLineThree}
                            </td>
                          </tr>
                          <tr>
                            <td style={{ padding: '4px' }}>
                              {city}
                              {state ? `, ${state.code}` : ''}
                            </td>
                          </tr>
                          <tr>
                            <td style={{ padding: '4px' }}>{postalCode}</td>
                          </tr>
                          <tr>
                            <td style={{ padding: '4px' }}>{addressType}</td>
                          </tr>
                          <tr>
                            <td style={{ padding: '4px' }}>
                              {isDefault ? 'Yes' : 'No'}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div className="row">
                    {!isDefault && (
                      <a
                        href="/"
                        className="right"
                        onClick={e => updateDefaultAddress(e, id)}
                      >
                        Make Default
                      </a>
                    )}
                  </div>
                </div>
              </div>
            );
          })}
      </div>
      <AddressModal
        isOpen={isAddressModalOpen}
        setIsOpen={setIsAddressModalOpen}
        address={selectedAddress}
        pharmacyId={pharmacy?.id}
        refresh={refresh}
      />
    </div>
  );
};

export default AddressesTab;
